import APIServices from './APIServices'

// Cache para evitar requests duplicadas - exactamente igual que managersAPI
let originDestinyCache: any = null
let cacheTimestamp = 0
const CACHE_DURATION = 5 * 60 * 1000 // 5 minutos

export interface OriginDestiny {
  id: number
  name: string
  description?: string
  countryId: number
}

export interface OriginDestinyResponse {
  totalItems: number
  currentPage: number
  totalPages: number
  items: OriginDestiny[]
}

export interface CreateOriginDestinyParams {
  name: string
  countryId: number
}

export interface UpdateOriginDestinyParams {
  name?: string
  description?: string
}

export const getOriginDestiny = async (params: {
  page?: number
  per_page?: number
  search?: string
}) => {
  // Si es una búsqueda vacía y tenemos cache válido, usar cache - EXACTO COMO managersAPI
  if (!params.search && originDestinyCache && (Date.now() - cacheTimestamp < CACHE_DURATION)) {
    return originDestinyCache
  }
  
  try {
    const cleanParams = Object.fromEntries(
      Object.entries(params || {}).filter(([_, value]) => value != null)
    )
    
    const response = await APIServices.get('/administration/origindestiny', { params: cleanParams })
    
    const responseData = response.data as OriginDestinyResponse
    const items = responseData?.items || []
    
    // Si es búsqueda vacía, guardar en cache - EXACTO COMO managersAPI
    if (!params.search) {
      originDestinyCache = items
      cacheTimestamp = Date.now()
    }
    
    return items
  } catch (error) {
    console.error('Error fetching origin destiny:', error)
    throw error
  }
}

export const createOriginDestiny = async (data: CreateOriginDestinyParams) => {
  const response = await APIServices.post('/administration/origindestiny', data)
  return response?.data
}

export const updateOriginDestiny = async (id: number, data: UpdateOriginDestinyParams) => {
  const response = await APIServices.patch(`/administration/origindestiny/${id}`, data)
  return response?.data
} 